export var Category;
(function (Category) {
    Category.types = ["groceries", "resturant", "health", "household", "hobby", "subscriptions", "transport", "misc"];
    function is(value) {
        return Category.types.includes(value);
    }
    Category.is = is;
})(Category || (Category = {}));
